
import "vue-collapsible-component/lib/vue-collapsible.css";
import PlusIcon from "@/assets/svg/heroicons/plus.svg?inline";
import CloseIcon from "@/assets/svg/heroicons/x.svg?inline";

export default {
  components: {
    PlusIcon,
    CloseIcon,
  },
  props: {
    productSlug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      faqs: [],
      faqItemsToShow: 4,
      firstFaqItem: 0,
      faqsLength: 0,
      displayFaqs: [],
    };
  },
  mounted() {
    this.loadFaqs();
  },
  methods: {
    isVisible(index) {
      return true;
    },
    async loadFaqs() {
      try {
        const { data } = await this.$axios.$get(
          "api/front/product/" + this.productSlug + "/faqs"
        );
        // const data = FaqsJsonData.data
        this.faqs = data;
        if (this.faqs.length > 0) {
          this.$emit("has-faq", true);
        } else {
          this.$emit("has-faq", false);
        }
      } catch (error) {
        // console.error(`Error connecting '/api/front/faqs'`)
      }
    },
  },
};
